module.exports = __webpack_public_path__ + "static/jobs-section-clouds-d761cc60522691401925958b7b01ad8c.png";